import { Button, Col, Row, Stack } from "react-bootstrap"
import useUXStore from "../../api/ux/store"
import ButtonControl from "../../components/ButtonControl"
import CStack from "../../components/CStack"
import AppItem from "../../containers/Applications/AppItem"
import { useEffect, useState } from "react"
import Label from "../../components/Label"
import Input from "../../components/Input"
import { useApps } from "../../api/apps/store"
import Loading from "../../components/Loading"
import { AppData, ClientData } from "../../api/apps/data"
import { useAuth } from "../../api/auth/store"
import { SUPPORT_ROLE } from "../../constants"

const defaultErr = { id: "", name: "" }

const AddAppView = ({ onAdded = () => { } }) => {
    const [adding, setAdding] = useState(false)
    const [app, setApp] = useState({ id: "", name: "", desc: "" })
    const [err, setErr] = useState(defaultErr)
    const { refreshDialog, hideDialog, addToast } = useUXStore(state => state)
    const { addApp } = useApps(state => state)

    const onAdd = () => {
        setAdding(true)
        refreshDialog({
            id: "addApp",
            onClose: undefined,
        }, false)
        setErr(defaultErr)
        addApp(app.id, app.name, app.desc).then(code => {
            console.log(code)
            if (code === "200") {
                addToast("", app.name + " successfully added!")
            } else {
                addToast("Failed", "Failed to add app " + app.name)
            }
            switch (code) {
                case "200":
                    hideDialog("addApp")
                    onAdded()
                    break;
                case "app_enrolled": // already enrolled
                    setErr({ id: "Id already taken.", name: "" })
                    break;
                case "incomplete_param":
                    setErr({ id: "Required", name: "Required" })
                    break
                default:
                    console.error(code)
                    break;
            }
        })
            .catch(err => {

            }).finally(() => {
                setAdding(false)
                refreshDialog({
                    id: "addApp",
                }, true)
            })
    }
    return <>
        <Stack gap={2}>
            <Row>
                <Col><Label>Id</Label> </Col>
                <Col><Input disabled={adding} label={err.id} error value={app.id} onChange={(e: any) => setApp({ ...app, id: e.target.value.replace(/[^a-zA-Z0-9._]/g, '') })} /> </Col>
            </Row>
            <Row>
                <Col><Label>Name</Label> </Col>
                <Col><Input disabled={adding} label={err.name} error onChange={(e: any) => setApp({ ...app, name: e.target.value })} /> </Col>
            </Row>
            <Row>
                <Col><Label>Description</Label> </Col>
                <Col><Input disabled={adding} onChange={(e: any) => setApp({ ...app, desc: e.target.value })} /> </Col>
            </Row>
            <Row>
                <Col><Button style={{ float: "right" }} onClick={onAdd} disabled={adding}>Add</Button></Col>
            </Row>
        </Stack>

    </>
}

const Applications = () => {
    const { sessionDetails, loadSession, hasRole } = useAuth(state => state)
    const { refreshDialog, addToast } = useUXStore(state => state)
    const { retrieveApps, apps, loading, removeApp, removeClient, updateApp } = useApps(state => state)

    useEffect(() => {
        if (!sessionDetails) {
            loadSession()
        }
    }, [sessionDetails])

    useEffect(() => {
        retrieveApps()
    }, [])
    const onAdd = () => {
        refreshDialog({
            id: "addApp",
            title: "Add App",
            visible: true,
            content: <AddAppView onAdded={onAdded} />,
            onConfirm: undefined,
        }, true)
    }
    const onDelete = (id: string) => {
        removeApp(id)
            .then(code => {
                switch (code) {
                    case "200":
                        addToast("", "Successfully removed app!")
                        //retrieveApps()
                        break;
                    default:
                        addToast("Failed", "Failed to remove app!")
                        break;
                }
            })
            .catch(err => {
                console.error(err)
            })
    }
    const onAdded = () => {
        retrieveApps()
    }
    const onUpdate = async (app: AppData) => {
        updateApp(app)
            .then(code => {
                switch (code) {
                    case "200":
                        addToast("", app.name + " updated successfully.")
                        break;
                    default:
                        addToast("", app.name + " update failed.")
                        break;
                }
            })
            .catch(err => {

            })
    }
    const onDeleteClient = (app: string, client: ClientData) => {
        removeClient(app, client.id)
            .then(code => {
                switch (code) {
                    case "200":
                        addToast("", client.desc + " removed successfully.")
                        break;
                    default:
                        addToast("", client.desc + " removed failed.")
                        break;
                }
            })
            .catch(err => {

            })
    }
    if (loading || !sessionDetails) return <Loading center />

    const canAdd = !hasRole(SUPPORT_ROLE)

    return <>
        {canAdd && <ButtonControl text="Add Application" buttonLabel="Add" onClicked={onAdd} />}
        <CStack header="Applications">
            {
                apps !== null && apps!.map(item =>
                    <AppItem app={item} onDelete={onDelete}
                        onUpdate={onUpdate}
                        onAddedClient={() => onAdded()}
                        onDeleteClient={(client) => onDeleteClient(item.id!, client)} />)
            }
        </CStack>
    </>
}

export default Applications